document.addEventListener("DOMContentLoaded", () => {
  if (window.__KB_QUOTE_INITIALIZED__) {
    console.warn("⚠️ Quote modal already initialized, skipping");
    return;
  }
  window.__KB_QUOTE_INITIALIZED__ = true;
  const btn = document.getElementById("btn-get-quote");
  if (!btn) return;

  // ====== LANG DICTIONARY ======
  const QUOTE_I18N = {
    de: {
      title: "Angebot anfordern",
      desc: "Bitte geben Sie Ihre E-Mail-Adresse ein:",
      placeholder: "E-Mail",
      cancel: "Abbrechen",
      send: "Senden",
      err_no_email: "❌ Bitte E-Mail-Adresse eingeben.",
      err_bad_email: "❌ Ungültige E-Mail-Adresse.",
      err_network: "❌ Netzwerkfehler. Bitte versuchen Sie es später erneut.",
      status_creating: "⏳ Angebot wird erstellt…"
    },
    en: {
      title: "Request a quote",
      desc: "Please enter your email address:",
      placeholder: "Email",
      cancel: "Cancel",
      send: "Send",
      err_no_email: "❌ Please enter your email address.",
      err_bad_email: "❌ Invalid email address.",
      err_network: "❌ Network error. Please try again later.",
      status_creating: "⏳ Generating quote…"
    },
    dk: {
      title: "Anmod om tilbud",
      desc: "Indtast venligst din e-mailadresse:",
      placeholder: "E-mail",
      cancel: "Annuller",
      send: "Send",
      err_no_email: "❌ Indtast venligst din e-mailadresse.",
      err_bad_email: "❌ Ugyldig e-mailadresse.",
      err_network: "❌ Netværksfejl. Prøv venligst igen senere.",
      status_creating: "⏳ Tilbud oprettes…"
    },
    es: {
      title: "Solicitar presupuesto",
      desc: "Por favor, introduzca su correo electrónico:",
      placeholder: "Correo electrónico",
      cancel: "Cancelar",
      send: "Enviar",
      err_no_email: "❌ Por favor, introduzca su correo electrónico.",
      err_bad_email: "❌ Dirección de correo no válida.",
      err_network: "❌ Error de red. Inténtelo de nuevo más tarde.",
      status_creating: "⏳ Generando presupuesto…"
    },
    nl: {
      title: "Offerte aanvragen",
      desc: "Voer alstublieft uw e-mailadres in:",
      placeholder: "E-mail",
      cancel: "Annuleren",
      send: "Verzenden",
      err_no_email: "❌ Voer uw e-mailadres in.",
      err_bad_email: "❌ Ongeldig e-mailadres.",
      err_network: "❌ Netwerkfout. Probeer het later opnieuw.",
      status_creating: "⏳ Offerte wordt aangemaakt…"
    }
  };

  // ====== PROGRESS STEPS ======
  const PROGRESS_STEPS = {
    de: [
      "⏳ Angebot wird erstellt…",
      "🛒 Warenkorb wird verarbeitet…",
      "🖼️ Bilder werden geladen…",
      "📄 PDF wird generiert…",
      "📧 E-Mail wird gesendet…"
    ],
    en: [
      "⏳ Creating quote…",
      "🛒 Processing cart…",
      "🖼️ Loading images…",
      "📄 Generating PDF…",
      "📧 Sending email…"
    ],
    dk: [
      "⏳ Opretter tilbud…",
      "🛒 Kurv behandles…",
      "🖼️ Billeder indlæses…",
      "📄 PDF genereres…",
      "📧 E-mail sendes…"
    ],
    es: [
      "⏳ Creando oferta…",
      "🛒 Procesando carrito…",
      "🖼️ Cargando imágenes…",
      "📄 Generando PDF…",
      "📧 Enviando correo…"
    ],
    nl: [
      "⏳ Offerte wordt aangemaakt…",
      "🛒 Winkelwagen wordt verwerkt…",
      "🖼️ Afbeeldingen worden geladen…",
      "📄 PDF wordt gegenereerd…",
      "📧 E-mail wordt verzonden…"
    ]
  };

  // ====== PROGRESSBAR ======
  function startProgressBar(lang) {
    const TOTAL_MS = 90_000;
    const steps = PROGRESS_STEPS[lang] || PROGRESS_STEPS.de;
    const stepDuration = TOTAL_MS / steps.length; // 18 сек на шаг

    const overlay = document.createElement('div');
    overlay.id = 'kb-progress-overlay';
    overlay.style.cssText = `
      position: fixed; inset: 0; background: rgba(0,0,0,0.55);
      display: flex; flex-direction: column;
      align-items: center; justify-content: center;
      z-index: 99999; font-family: Arial, sans-serif;
    `;
    overlay.innerHTML = `
      <div style="background:#fff; border-radius:0px; padding:32px 40px;
                  min-width:320px; max-width:90%; text-align:center;
                  box-shadow:0 8px 32px rgba(0,0,0,0.25);">
        <div id="kb-progress-status"
             style="font-size:15px; color:#333; margin-bottom:20px; min-height:24px;">
          ${steps[0]}
        </div>
        <div style="background:#eee; border-radius:0px; height:10px; overflow:hidden;">
          <div id="kb-progress-bar"
               style="height:100%; width:0%; background:#910045;
                      border-radius:0px; transition:width 0.4s ease;"></div>
        </div>
        <div id="kb-progress-pct"
             style="margin-top:10px; font-size:13px; color:#888;">0%</div>
      </div>
    `;
    document.body.appendChild(overlay);

    const barEl    = document.getElementById('kb-progress-bar');
    const statusEl = document.getElementById('kb-progress-status');
    const pctEl    = document.getElementById('kb-progress-pct');

    const startTime = Date.now();
    let stopped = false;
    let rafId;

    function tick() {
      if (stopped) return;
      const elapsed  = Date.now() - startTime;
      const pct      = Math.min(elapsed / TOTAL_MS * 100, 99);
      const stepIdx  = Math.min(Math.floor(elapsed / stepDuration), steps.length - 1);

      barEl.style.width    = pct.toFixed(1) + '%';
      pctEl.textContent    = Math.floor(pct) + '%';
      statusEl.textContent = steps[stepIdx];

      if (elapsed < TOTAL_MS) rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);

    return function stop(success = true) {
      stopped = true;
      cancelAnimationFrame(rafId);
      if (success) {
        barEl.style.width    = '100%';
        pctEl.textContent    = '100%';
        statusEl.textContent = '✅';
      }
      setTimeout(() => overlay.remove(), success ? 1200 : 0);
    };
  }

  window.getCurrentLanguage = function() {
    const domain = window.location.hostname;
    if (domain.includes("dk.toproset.eu")) return "dk";
    if (domain.includes("nl.toproset.eu")) return "nl";
    if (domain.includes("es.toproset.eu")) return "es";
    if (domain.includes("en.toproset.eu")) return "en";
    return "de";
  };
  const lang = getCurrentLanguage();
  const T = QUOTE_I18N[lang] || QUOTE_I18N.de;
  
  // ====== Stale cart check ======
  const STALE_I18N = {
    de: { title: "Warenkorb wurde geändert", desc: "Der Warenkorb wurde in einem anderen Tab geändert. Bitte laden Sie die Seite neu, bevor Sie ein Angebot anfordern.", ok: "Seite neu laden" },
    en: { title: "Cart has changed", desc: "The cart was modified in another tab. Please reload the page before requesting a quote.", ok: "Reload page" },
    es: { title: "El carrito ha cambiado", desc: "El carrito se modificó en otra pestaña. Actualice la página antes de solicitar el presupuesto.", ok: "Actualizar página" },
    nl: { title: "Winkelwagen is gewijzigd", desc: "De winkelwagen is in een ander tabblad gewijzigd. Vernieuw de pagina voordat u een offerte aanvraagt.", ok: "Pagina vernieuwen" },
    dk: { title: "Kurven er ændret", desc: "Kurven blev ændret i en anden fane. Genindlæs siden, før du anmoder om et tilbud.", ok: "Genindlæs siden" }
  };
  const TS = STALE_I18N[lang] || STALE_I18N.de;

  async function isCartStale() {
    const c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const domKeys = new Set(
      [...document.querySelectorAll('.item-row[data-product-id]')].map(r => r.dataset.productId)
    );
    const missing = c.items.filter(i => !domKeys.has(i.key)).map(i => i.key);
    const extra   = [...domKeys].filter(k => !c.items.some(i => i.key === k));
    if (missing.length || extra.length) console.warn('⚠️ Cart stale', { missing, extra });
    return missing.length > 0 || extra.length > 0;
  }

  let staleModalShown = false;
  function showStaleModal() {
    if (staleModalShown) return;
    staleModalShown = true;
    const el = document.createElement('div');
    el.id = 'kb-stale-modal';
    el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.6);z-index:99999;display:flex;align-items:center;justify-content:center;';
    el.innerHTML = `
      <div style="background:#fff;padding:25px;width:90%;max-width:420px;box-shadow:0 0 15px rgba(0,0,0,0.3);font-family:Arial,sans-serif;">
        <h3 style="font-size:20px;margin-bottom:10px;">${TS.title}</h3>
        <p style="margin-bottom:20px;">${TS.desc}</p>
        <div style="text-align:right;">
          <button id="kb-stale-reload" style="background:#910045;color:#fff;border:none;padding:8px 14px;cursor:pointer;">${TS.ok}</button>
        </div>
      </div>`;
    document.body.appendChild(el);
    document.getElementById('kb-stale-reload').addEventListener('click', () => location.reload());
  }

  // bfcache («Назад») — перезагрузить молча
  window.addEventListener('pageshow', e => { if (e.persisted) location.reload(); });
  // ====== Create modal ======
  if (!document.getElementById("quote-modal")) {
    const modalHTML = `
      <div id="quote-modal" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;
          background:rgba(0,0,0,0.6);z-index:9999;align-items:center;justify-content:center;">
        <div id="quote-modal-content" style="background:white;padding:25px;border-radius:0px;width:90%;max-width:420px;box-shadow:0 0 15px rgba(0,0,0,0.3);">
          <h3 style="font-size:20px;margin-bottom:10px;">${T.title}</h3>
          <p style="margin-bottom:10px;">${T.desc}</p>
          <input type="email" id="quote-email" placeholder="${T.placeholder}"
                style="width:100%;padding:8px;border:1px solid #ccc;border-radius:0px;margin-bottom:15px;">
          <p id="quote-status" style="margin-bottom:10px;font-size:14px;color:#666;"></p>
          <div style="text-align:right;">
            <button id="quote-cancel" style="background:#ccc;border:none;padding:8px 14px;margin-right:8px;border-radius:0px;cursor:pointer;">${T.cancel}</button>
            <button id="quote-send" style="background:#910045;color:white;border:none;padding:8px 14px;border-radius:0px;cursor:pointer;">${T.send}</button>
          </div>
        </div>
      </div>`;
    document.body.insertAdjacentHTML("beforeend", modalHTML);
  }

  const modal      = document.getElementById("quote-modal");
  const inputEmail = document.getElementById("quote-email");
  const cancelBtn  = document.getElementById("quote-cancel");
  const btnSend    = document.getElementById("quote-send");
  const statusEl   = document.getElementById("quote-status");

  // ====== Currency ======
  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    const moneyElement = document.querySelector('.money');
    if (moneyElement) {
      const text = moneyElement.textContent.trim();
      if (text.includes('€')) return 'EUR';
      if (text.includes('$')) return 'USD';
      if (text.includes('£')) return 'GBP';
      if (text.includes('kr')) return 'DKK';
    }
    const domain = window.location.hostname;
    if (domain.includes("dk.toproset.eu")) return "DKK";
    return "EUR";
  }

  // ====== Selectors ======
  // ====== Selectors ======
  function getSelectorsData() {
    const selectors = {};

    // Цвета фольги: по одной записи на каждую ВИДИМУЮ группу
    document.querySelectorAll('.kb-foil-group.visible').forEach(group => {
      const checked = group.querySelector('input.foil-selector:checked');
      if (!checked) return;

      const labelEl = group.querySelector('.foil-label-text');
      const key = labelEl
        ? labelEl.textContent.trim().replace(/:\s*$/, '')
        : 'Foil Color ' + (group.dataset.groupId || '');

      const valueEl = group.querySelector('.foil-selected-value');
      const value = (valueEl && valueEl.textContent.trim())
        ? valueEl.textContent.trim()
        : (checked.dataset.color || '');

      if (key && value) selectors[key] = value;
    });

    const customerSelector = document.querySelector('.kb-customer-selector input[type="radio"]:checked');
    if (customerSelector) {
      const customerLabelElement = document.querySelector('.customer-label-text');
      let customerKey = customerLabelElement ? customerLabelElement.textContent.trim() : 'Customer Type';
      customerKey = customerKey.replace(/\s*(auswählen|select|kies|vælg|seleccionar)/gi, '').trim();
      const customerLabel = document.querySelector(`label[for="${customerSelector.id}"] .customer-option-text`);
      selectors[customerKey] = customerLabel ? customerLabel.textContent.trim() : customerSelector.value;
    }

    const datePicker = document.querySelector('b2b-date-picker #delivery-date');
    if (datePicker && datePicker.value) {
      const dateKey = datePicker.getAttribute('name') || 'Veranstaltungsdatum';
      selectors[dateKey] = datePicker.value;
    }

    const commissionField = document.querySelector('b2b-date-picker #commission-field');
    if (commissionField && commissionField.value.trim()) {
      const commissionKey = commissionField.getAttribute('name') || 'Kommission';
      selectors[commissionKey] = commissionField.value.trim();
    }

    return selectors;
  }
  /* nur 1 Druckfarbe
  function getSelectorsData() {
    const selectors = {};
    const foilSelector = document.querySelector('.kb-foil-selector input[type="radio"]:checked');
    if (foilSelector) {
      const foilLabelElement = document.querySelector('.foil-label-text');
      const foilKey = foilLabelElement ? foilLabelElement.textContent.trim().replace(':', '') : 'Foil Color';
      const foilValue = document.querySelector('.foil-selected-value');
      selectors[foilKey] = foilValue ? foilValue.textContent.trim() : foilSelector.dataset.name;
    }
    const customerSelector = document.querySelector('.kb-customer-selector input[type="radio"]:checked');
    if (customerSelector) {
      const customerLabelElement = document.querySelector('.customer-label-text');
      let customerKey = customerLabelElement ? customerLabelElement.textContent.trim() : 'Customer Type';
      customerKey = customerKey.replace(/\s*(auswählen|select|kies|vælg|seleccionar)/gi, '').trim();
      const customerLabel = document.querySelector(`label[for="${customerSelector.id}"] .customer-option-text`);
      selectors[customerKey] = customerLabel ? customerLabel.textContent.trim() : customerSelector.value;
    }
    const datePicker = document.querySelector('b2b-date-picker #delivery-date');
    if (datePicker && datePicker.value) {
      const dateKey = datePicker.getAttribute('name') || 'Veranstaltungsdatum';
      selectors[dateKey] = datePicker.value;
    }

    const commissionField = document.querySelector('b2b-date-picker #commission-field');
    if (commissionField && commissionField.value.trim()) {
      const commissionKey = commissionField.getAttribute('name') || 'Kommission';
      selectors[commissionKey] = commissionField.value.trim();
    }
    return selectors;
  }
  */
  // ====== Properties parser ======
  function parseProperties(propertiesHTML) {
    if (!propertiesHTML) return {};
    const properties = {};
    const parser = new DOMParser();
    const doc = parser.parseFromString(propertiesHTML, 'text/html');
    const smalls = doc.querySelectorAll('small');
    smalls.forEach(small => {
      const text = small.innerHTML;
      const lines = text.split('<br>');
      lines.forEach(line => {
        const strongMatch = line.match(/<strong>(.*?):<\/strong>\s*(.*)/);
        if (strongMatch) {
          const key = strongMatch[1].trim();
          let value = strongMatch[2].trim();
          const valueDoc = parser.parseFromString(value, 'text/html');
          const link = valueDoc.querySelector('a');
          if (link && link.href && !link.classList.contains('pplr_slide')) {
            value = link.href;
          } else {
            value = valueDoc.body.textContent.trim();
          }
          properties[key] = value;
        }
      });
    });
    return properties;
  }

  // ====== Cart data ======
  async function getVisibleCartData() {
    const res = await fetch("/cart.js");
    const cartAPI = await res.json();
    const apiItemsMap = {};
    cartAPI.items.forEach(item => { apiItemsMap[item.key] = item; });

    const items = [];
    const cartRows = document.querySelectorAll('.item-row');

    cartRows.forEach(row => {
      let dataProductId = row.getAttribute('data-product-id');
      let key = dataProductId;
      if (!key) return;
      const apiItem = apiItemsMap[key];
      if (!apiItem) { console.warn(`⚠️ Product ${key} not found in /cart.js API`); return; }
      const variantId = parseInt(key.split(':')[0]);
      const titleEl = row.querySelector('.item-title h5 a');
      const title = titleEl ? titleEl.textContent.trim() : apiItem.title;
      const variantEl = row.querySelector('.variants');
      const variantTitle = variantEl ? variantEl.textContent.trim() : apiItem.variant_title;
      const qtyInput = row.querySelector('input.quantity');
      const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      
      //const origPriceEl = row.querySelector('.offers[data-integration-price-original="1"] .money');
      //const originalPrice = origPriceEl
      //  ? parseFloat(origPriceEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."))
      //  : (apiItem.original_price / 100);
      //const discPriceEl = row.querySelector('.offers[data-integration-price-created="1"] .money');

      const origPriceEl = row.querySelector('.offers[data-integration-price-original="1"] .money, [data-integration-price-original="1"] .money');
      const originalPrice = origPriceEl
        ? parseFloat(origPriceEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."))
        : (apiItem.original_price / 100);
      const discPriceEl = row.querySelector('.offers[data-integration-price-created="1"] .money, [data-integration-price-created="1"] .money');

      const displayedPrice = discPriceEl
        ? parseFloat(discPriceEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."))
        : (apiItem.final_price / 100);
      const origTotalEl = row.querySelector('.total-line[data-integration-price-original="1"] .money');
      const originalTotal = origTotalEl
        ? parseFloat(origTotalEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."))
        : (originalPrice * quantity);
      const discTotalEl = row.querySelector('.total-line[data-integration-price-created="1"] .money');
      const totalLine = discTotalEl
        ? parseFloat(discTotalEl.textContent.replace(/[^\d,.-]/g, "").replace(",", "."))
        : (displayedPrice * quantity);
      const discount = Math.max(0, originalPrice - displayedPrice);
      const totalDiscount = Math.max(0, originalTotal - totalLine);
      const propertiesEl = row.querySelector('h6');
      const propertiesHTML = propertiesEl ? propertiesEl.innerHTML : '';
      const visibleProperties = parseProperties(propertiesHTML);
      const properties = { ...(apiItem.properties || {}), ...visibleProperties };
      let image = null;
      if (properties.Preview) { image = properties.Preview; }
      else { const img = row.querySelector('img[data-id]'); image = img ? img.getAttribute('data-source') : null; }
      if (!image) { image = apiItem.image; }
      const url = titleEl ? titleEl.getAttribute('href') : apiItem.url;
      if (items.some(i => i.key === key)) return;
      items.push({
        id: apiItem.id, variant_id: variantId, product_id: apiItem.product_id, key,
        title, variant_title: variantTitle, sku: apiItem.sku, quantity,
        original_price: originalPrice, displayed_price: displayedPrice, discount,
        total_line: totalLine, total_discount: totalDiscount, properties, image, url,
        requires_shipping: apiItem.requires_shipping,
        product_type: apiItem.product_type || '',
        is_auto_added: properties._auto_added === "true",
        parent_key: properties._parent_keys || null
      });
    });

    const processedKeys = new Set(items.map(i => i.key));
    console.log('📦 processedKeys перед API-fallback:', [...processedKeys]);
    cartAPI.items.forEach(item => {
      if (processedKeys.has(item.key)) return;
      const props = item.properties || {};
      items.push({
        id: item.id, variant_id: item.variant_id, product_id: item.product_id, key: item.key,
        title: item.title, variant_title: item.variant_title, sku: item.sku, quantity: item.quantity,
        original_price: item.original_price / 100, displayed_price: item.final_price / 100,
        discount: Math.max(0, (item.original_price - item.final_price) / 100),
        total_line: (item.final_price * item.quantity) / 100,
        total_discount: Math.max(0, (item.original_price - item.final_price) / 100 * item.quantity),
        properties: props, image: props.Preview || item.image, url: item.url,
        requires_shipping: item.requires_shipping, product_type: item.product_type || '',
        is_auto_added: props._auto_added === "true", parent_key: props._parent_keys || null
      });
    });

    const totalDiscount = items.reduce((sum, i) => sum + (i.total_discount || 0), 0);
    const subtotal = items.reduce((sum, i) => sum + i.total_line, 0);
    return { items, totalDiscount, subtotal, currency: getCurrency(), item_count: items.length };
  }

  // ====== Modal controls ======
  btn.addEventListener("click", async () => {
    btn.disabled = true; btn.style.opacity = "0.6";
    let stale = false;
    try { stale = await isCartStale(); } catch (e) { console.warn('stale check failed', e); }
    btn.disabled = false; btn.style.opacity = "1";
    if (stale) { showStaleModal(); return; }
    modal.style.display = "flex";
    inputEmail.value = "";
    statusEl.textContent = "";
  });
  cancelBtn.addEventListener("click", () => { modal.style.display = "none"; });
  modal.addEventListener("click", (e) => { if (e.target === modal) modal.style.display = "none"; });

  // ====== Send ======
  btnSend.addEventListener("click", async () => {
    const email = inputEmail.value.trim();

    if (!email) {
      statusEl.textContent = T.err_no_email;
      statusEl.style.color = "#dc2626";
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      statusEl.textContent = T.err_bad_email;
      statusEl.style.color = "#dc2626";
      return;
    }

    btnSend.disabled = true;
    btnSend.style.opacity = "0.6";
    modal.style.display = "none"; // скрываем модал, показываем прогрессор

    const stopProgress = startProgressBar(lang);

    try {
      const cart = await getVisibleCartData();
      const selectors = getSelectorsData();

      const response = await fetch("https://toproset-angebot-1077249420375.europe-west1.run.app", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, cart, lang, selectors, pplr_threshold: window.PPLR_PRICE_THRESHOLD || 0 })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        stopProgress(true); // полоса до 100%, исчезает через 1.2с
      } else {
        console.warn("❌:", data);
        stopProgress(false);
        statusEl.textContent = `❌ ${data.message || data.error || "Unbekannter Fehler"}`;
        statusEl.style.color = "#dc2626";
        modal.style.display = "flex"; // возвращаем модал с ошибкой
      }
    } catch (err) {
      console.error("❌ Network error:", err);
      stopProgress(false);
      statusEl.textContent = T.err_network;
      statusEl.style.color = "#dc2626";
      modal.style.display = "flex"; // возвращаем модал с ошибкой
    } finally {
      btnSend.disabled = false;
      btnSend.style.opacity = "1";
    }
  });

  window.getVisibleCartData = getVisibleCartData;
});